enum AuthorizedStatus {
    AUTHORIZED = 1,
    PENDING = 2,
    UNAUTHORIZED = 3
}

export {AuthorizedStatus}